import axios from "axios"

export default {
    GET_YIELD_PREDICTION_LIST: '/yield-prediction',
    GET_YIELD_PREDICTION_DETAILS: '/yield-prediction',
    GET_CROP_LIST: '/yield-prediction/get-crop-list',
    CREATE_YIELD_PREDICTION: '/yield-prediction',
    DELETE_YIELD_PREDICTION: '/yield-prediction',

    async getYieldPredictionLists(params) {
        try {
            const { data } = await axios.get(this.GET_YIELD_PREDICTION_LIST, {
                params: params
            })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    async getYieldPredictionDetails(id) {
        try {
            const { data } = await axios.get(`${this.GET_YIELD_PREDICTION_DETAILS}/${id}`)
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    // Server-rendered PDF (puppeteer/EJS) — `formData` optionally carries a
    // single client-captured map screenshot under the `image` field.
    async downloadReport(id, formData) {
        try {
            const response = await axios.post(
                `${this.GET_YIELD_PREDICTION_DETAILS}/${id}/download-report`,
                formData,
                { responseType: 'blob' }
            )
            return Promise.resolve(response)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    async getCropList() {
        try {
            const { data } = await axios.get(this.GET_CROP_LIST)
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    async createYieldPrediction(payload) {
        try {
            const formData = new FormData();
            Object.keys(payload).forEach(key => {
                if (payload[key] !== null && payload[key] !== undefined) {
                    if (typeof payload[key] === 'object' && !(payload[key] instanceof File)) {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }
            });

            const response = await axios.post(this.CREATE_YIELD_PREDICTION, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            
            // Check if response indicates failure (even if HTTP status is 200)
            if (response.data && response.data.success === false) {
                return Promise.reject({
                    response: {
                        data: response.data
                    }
                });
            }
            
            return Promise.resolve(response)
        } catch (error) {
            return Promise.reject(error.response || error)
        }
    },

    async deleteYieldPrediction(id) {
        try {
            const { data } = await axios.delete(`${this.DELETE_YIELD_PREDICTION}/${id}`)
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    async getYieldPredictionFeedback(id) {
        try {
            const { data } = await axios.get(`${this.GET_YIELD_PREDICTION_DETAILS}/${id}/feedback`)
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    async submitYieldPredictionFeedback(id, payload) {
        try {
            const { data } = await axios.post(
                `${this.GET_YIELD_PREDICTION_DETAILS}/${id}/feedback`,
                payload
            )
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    },

    // Alias used by shared FeedbackDialog
    async submitFeedback(id, payload) {
        return this.submitYieldPredictionFeedback(id, payload)
    },
}

